import DemandForm from './_form'
import template from './edit.pug'

export default Vue.extend({
  template: template(),
  components: {
    DemandForm
  },
  data() {
    return {
      ready: false,
      data: {},
      errors: {}
    }
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler() {
        this.$setPageTitle(this.$t('offerAndDemand.edit.title'))
        this.loadData()
      }
    }
  },

  methods: {
    loadData() {
      this.ready = false

      API.leadTrade.show(this.$route.params.id).then(response => {
        this.data = response

        this.$setBreadcrumbs([
          {
            label: this.$t('breadcrumbs.offer-and-demand.index'),
            route: {name: 'offer-and-demand-index'}
          },
          {
            label: this.$t('breadcrumbs.offer-and-demand.edit',
              {
                name: ''
              }),
            route: {}
          }
        ])

        this.ready = true
      })
    },

    updateDemand(data) {
      API.leadTrade.update(this.$route.params.id, data).then(() => {
        this.$notifications.success(this.$t('offerAndDemand.edit.succesfullyUpdated'))
        this.$router.push({name: 'offer-and-demand-index'})
      }, errors => {
        this.errors = errors
      })
    }
  }
})
